<template>
  <main class="page-main">
    <section class="page-hero">
      <div class="container page-hero__inner">
        <h1>About New Shivam Medicos</h1>
        <p>
          A neighbourhood retail pharmacy serving Basistha and surrounding areas of Guwahati, Assam —
          dispensing medicines safely, stocking trusted health products, and supporting families with
          clear, pharmacist-led guidance.
        </p>
      </div>
    </section>
    <article class="page-article">
      <h2>Who we serve</h2>
      <p>
        We welcome walk-in customers from South Basistha Nagar, Chariali, areas near Shiv Mandir, and anyone
        searching for a reliable <strong>medical store near Basistha</strong> or <strong>pharmacy near me</strong>
        in Guwahati. Whether you need an over-the-counter remedy, a chronic prescription refill, or advice on
        how to take your medicines, our team aims to help you quickly and respectfully.
      </p>

      <h2>Our approach</h2>
      <ul>
        <li>Prescription verification and dispensing in line with applicable pharmacy practice.</li>
        <li>Wide range of medicines, wellness items, and daily health essentials.</li>
        <li>Practical support such as blood pressure checks and medication-related queries (where available in-store).</li>
        <li>Clear communication — we explain what we can and cannot advise on, and when to see a doctor.</li>
      </ul>

      <h2>Opening hours</h2>
      <p>
        We are typically open <strong>8:30 AM – 2:00 PM</strong> and <strong>4:00 PM – 10:00 PM</strong> (subject to change on
        holidays; please call ahead). For the latest timings or to check stock before you travel, phone
        <a href="tel:+918876499294">+91 8876499294</a>.
      </p>

      <h2>Find us</h2>
      <p>
        <strong>New Shivam Medicos</strong><br />
        South Basistha Nagar, near Durga Mandir, Basistha, Guwahati, Assam.
        <a href="https://g.co/kgs/h3d5zFG" target="_blank" rel="noopener noreferrer">Open in Google Maps</a>.
      </p>

      <p class="note">
        This page describes our shop in general terms. Drug sales and services follow local law and
        professional rules; availability of specific services may vary — ask in store or by phone.
      </p>
    </article>
  </main>
</template>

<script>
export default {
  name: "AboutPage",
};
</script>
